import { render } from "./RectangleSelection.vue?vue&type=template&id=176c206a"
import script from "./RectangleSelection.vue?vue&type=script&lang=js"
export * from "./RectangleSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__